import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Paragraph } from '@digdir/designsystemet-react';
import { CheckmarkIcon } from '@navikt/aksel-icons';
import { SurveyMessage } from './SurveyMessage';
import classes from '../WorkEnvironmentFormSubmission.module.css';

export const SurveyThankYou = (): ReactElement => {
  const { t } = useTranslation();
  return (
    <SurveyMessage
      tone="success"
      icon={<CheckmarkIcon aria-hidden />}
      title={t('workEnvironmentFormSubmission.thanks.title')}
    >
      <Paragraph data-size="lg" className={classes.subtle}>
        {t('workEnvironmentFormSubmission.thanks.text')}
      </Paragraph>
      <Paragraph data-size="sm" className={classes.subtle}>
        {t('workEnvironmentFormSubmission.thanks.close')}
      </Paragraph>
    </SurveyMessage>
  );
};
